import { render, staticRenderFns } from "./chance-detail.vue?vue&type=template&id=6e8b037d&scoped=true&"
import script from "./chance-detail.vue?vue&type=script&lang=js&"
export * from "./chance-detail.vue?vue&type=script&lang=js&"
import style0 from "./chance-detail.vue?vue&type=style&index=0&id=6e8b037d&scoped=true&lang=scss&"
import style1 from "./chance-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8b037d",
  null
  
)

export default component.exports